module.exports = __webpack_public_path__ + "static/img/cp_4.7e1415e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp_4.png
// module id = 6ZyE
// module chunks = 0